import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export function NotFound() {
  const { t } = useApp();
  return (
    <div className="max-w-md mx-auto p-16 text-center">
      <div className="font-display text-8xl">404</div>
      <p className="mt-4">{t("notFound")}</p>
      <Link to="/" className="gg-btn-primary inline-flex mt-6">{t("goHome")}</Link>
    </div>
  );
}

